import { setDefaults, getRenderElement } from '@udecode/slate-plugins';
import paragraphElement from './element';

const renderParagraph = options => {
  const { p } = setDefaults(options, paragraphElement);

  return getRenderElement(p);
};

export default renderParagraph;
